import { formatPrice } from './money';
import type { OfferPreview } from './pendingOffer';

/**
 * The customer-facing price line for a selected offer (walkthrough F-35):
 * "$39.00 / month", or an honest "shown at checkout" when the server sent no
 * amount or no currency. Never raw minor units.
 */
export function offerPriceLabel(preview: Pick<OfferPreview, 'price' | 'currency' | 'billing_period'>): string {
  return formatPrice(preview.price, preview.currency, preview.billing_period ?? 'month') ?? 'shown at checkout';
}
